import React from 'react';
import TeamDetailsModuleProps from './type';
import RiderDetails from '../../components/RiderDetails';
import RiderTeamHistory from '../../components/RiderTeamHistory';
import './styles.scss';

const RiderDetailsModule = ({
  details,
  history,
}: TeamDetailsModuleProps) => (
  <div className="rider-details-module page-template">
    {details && <RiderDetails {...details} />}
    {history && <RiderTeamHistory {...history} />}
  </div>
);

export default RiderDetailsModule;
